import { SignIn } from "@clerk/react";
import { useSearch } from "wouter";
import logoImage from "@assets/Live_(1500_x_500_px)_(2)_1780520244305.png";
import { sanitizeRedirectUrl } from "@/lib/sanitizeRedirectUrl";

export default function ClerkSignIn() {
  const search = useSearch();
  const params = new URLSearchParams(search);
  const redirectUrl = sanitizeRedirectUrl(
    params.get("redirect_url") ?? params.get("returnTo") ?? "/",
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#030a14",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // flex-start + paddingTop so content isn't vertically centered and
        // clipped when the soft keyboard shrinks the visible area on mobile.
        justifyContent: "flex-start",
        paddingTop: "clamp(20px, 8vh, 60px)",
        paddingBottom: "24px",
        paddingLeft: "24px",
        paddingRight: "24px",
        gap: "24px",
        overflowY: "auto",
      }}
    >
      <img src={logoImage} alt="LiveSwell" style={{ height: 36, objectFit: "contain" }} />
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        fallbackRedirectUrl={redirectUrl}
      />
    </div>
  );
}
